import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_GSC_REVIEW_KEY } from '../../constants/queryKeys';
import { GET_GSC_REVIEW_URL } from '../../constants/apiUrls';
import { UploadedFileModel } from './useGetUploadedFileInfo';
import { GroupScType } from '../../models/SpecialConsideration';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface GetGroupSCReviewResponse {
  subjectDetail: {
    examLevel: string;
    examSeries: string;
    subject: string;
    modeOfAssessment: string;
    examDate: string;
  };
  specialConsiderationDetail: {
    specialConsiderationType: string;
    reason: string;
    explanation: string;
  };
  examCentre: string;
  fileNames: UploadedFileModel[];
  groupScType: GroupScType;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: GetGroupSCReviewResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetGroupSCReview = ({ uuid, onSuccess, onError }: Input) => {
  const getGroupSCReview = async () => {
    const res = await axiosClient.get<GetGroupSCReviewResponse>(GET_GSC_REVIEW_URL(uuid));
    return res.data;
  };
  return useCustomQuery([GET_GSC_REVIEW_KEY], getGroupSCReview, {
    onSuccess,
    onError,
  });
};
